export default __webpack_public_path__ + "static/media/bannerImg3.1ee3d28b.jpeg";